module.exports = __webpack_public_path__ + "static/media/gronsakshjalpen.48ded544.jpg";